import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";
export const walletCardReloadState = atom({
  key: 'walletCardReloadState',
  default: false,
  effects: []
});
